type Input<O> = {
  [K in keyof O]: O[K] | false | null | undefined
}

export function omit<O>(object: Input<O>): Partial<O> {
  const copy: any = {}
  for (const [key, value] of Object.entries(object)) {
    if (value == null || value === false) continue
    copy[key] = value
  }
  return copy
}

type Output<T, Not> = {
  [K in keyof T]: T[K] extends Not ? never : T[K]
}

export function omitBy<In, Out>(object: In, skip: (o: unknown) => boolean): Out {
  const copy: any = {}
  for (const [key, value] of Object.entries(object as {})) {
    if (!skip(value)) copy[key] = value
  }
  return copy
}

export function omitUndefined<T extends object>(object: T): Output<T, undefined> {
  return omitBy(object, v => v === undefined)
}

export function omitNil<T extends object>(object: T): Output<T, undefined> {
  return omitBy(object, v => v == null)
}
